import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '漫蛙漫画网',
  url: 'https://manwacomics.com',
  description: '漫蛙漫画网提供海量免费韩漫、日漫、国漫资源，涵盖漫画大全与漫画全集，支持高清在线阅读。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://manwacomics.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '漫蛙漫画网',
  url: 'https://manwacomics.com',
  description: '免费韩漫日漫国漫在线阅读平台',
  sameAs: [
    'https://weibo.com/manwacomics',
    'https://www.wechat.com/manwacomics',
  ],
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={orgSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}